import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
/*import { OrderByPipe } from '@angular/common';*/

import * as _ from 'lodash';
import { TableViewService } from '../../table-view.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';


@Component({
  selector: 'app-table1-component',
  templateUrl: './table1-component.component.html',
  styleUrls: ['./table1-component.component.scss']
  /*changeDetection: ChangeDetectionStrategy.OnPush*/
  // providers: [OrderByPipe],
})
export class Table1ComponentComponent implements OnInit, OnDestroy {
  jsonData: any;
  data: any;
  tableData: any;
  headers: any;
  valuesArray: any = {
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    data7: [],
    data8: [],
    data9: [],
    data10: []

  };
  usaValues: any;
  properties: any;
  tableTitle: any;
  categories: any[] = [];
  p: number = 1; // Current page
  itemsPerPage: any; // Number of items per page
  valuesArray2: any;
  headers1: any[] = [];
  sortcolumn: string | null = null;
  headers2: any;
  start: any;
  end: any;
  significanceValue: any = "None";
  chartMainData: any = [];
  rowLayout: any = false;
  tableContent: any;
  clickCounts: { [key: string]: number } = {};
  categories2: any;
  dataCellCache: { [key: string]: any } = {}
  trans: any;
  userselectedchartdata: any;
  sorting: any = 'nosort';
  sortDirectionAsc: any = true;
  sortDirectionDesc: any = true;
  header2: any = [];
  Output: any = false;
  DefaultConfidenceLevel: any = "";
  SigValue = "None";
  ConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  selectedColumn: any = '';
  selectedascending: any = '';
  CurrentWidgetName: any = "";
  bipsDefaultColor: any = '#CAC4C4';

  @Input() popUp: any = false;
  @Input() customData: any;
  @Input() enableDataBars: boolean = false;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any = false;
  @Input() globalColorMap: { [key: string]: string } = {};
  constructor(private http: HttpClient, public tableService: TableViewService, private sanitizer: DomSanitizer, private router: Router,
    private route: ActivatedRoute, private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService) { }
  @ViewChild('customTable') customTable: ElementRef | undefined;
  @ViewChild('headerElement') headerElement: ElementRef | undefined;
  @ViewChildren('dataCell') dataCells: QueryList<ElementRef> | any;
  private subscriptions: Subscription = new Subscription();
  private originalChartMainData: any[] | null = null;
  private originalCategories: any[] | null = null;
  ngOnInit() {

    if (this.isOutput) {
      let Properties = JSON.parse(this.customData.customizationProperties);

      let Properties1;
      for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
        if (this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
          Properties1 = JSON.parse(this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties);
        }
      }
      if (Properties1.selectedColumn != undefined) {
        Properties.selectedColumn = Properties1.selectedColumn;
      }
      if (Properties1.selectedsorting != undefined) {
        Properties.selectedsorting = Properties1.selectedsorting;
      }
      this.properties = Properties;
      // // Default hideNA to true if not explicitly set
      // if (this.properties.hideNA === undefined) {
      //   this.properties.hideNA = true;
      // }
      if (this.customData) {
        for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
          if (this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
            this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(Properties);
          }
        }
      }
      this.CurrentWidgetName = this.customData.widget_name;
      this.customData = this.customData.metric[0];
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updatesig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updatesig();
        }));
      //this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.preparemainChartData(this.customData);
      this.getData(this.chartMainData, 0, this.itemsPerPage, "", 'nosort');
    }
    else {
      this.http.get<any>('assets/Data/tableData.json').subscribe((data: any) => {
        this.jsonData = data;

        this.data = data[0];
        this.properties = data[0]["properties"][0];
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.tableData = data;
        this.tableContent = data;
        this.header2 = [];
        this.header2.push('Metric2');
        this.header2.push('asc');
        this.getData(this.tableData[0].data, 0, this.itemsPerPage, "", 'nosort');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: 'nosort' };
        });

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category, sortorder: 'nosort' };
        });
        // For headers
        this.headers2 = this.headers.map((category: any, index: number) => {
          return { colname: category, sortorder: index === 1 ? 'asc' : 'nosort' };
        });

        // For categories
        this.categories2 = this.categories.map((category, index) => {
          return { colname: category, sortorder: index === 0 ? 'asc' : 'nosort' };
        });

        const allCategoryNames: string[] = this.tableData[0].data.map((item: { [x: string]: string }) => item['Category Name']);

        // Use Set to get unique category names
        const uniqueCategoryNames: string[] = Array.from(new Set(allCategoryNames));

        // Calculate the length of unique category names
        const uniqueCategoryNamesLength: number = uniqueCategoryNames.length;
        this.itemsPerPage = 10;
        this.tableTitle = this.tableData[0].title;

        this.customization(); //function to customize the table
        localStorage.setItem("properties", JSON.stringify(this.properties));
      });
    }


    const tableLeftFixedDiv = document.querySelector('.table-bodys2') as HTMLElement;
    const tableFreezFixedDiv = document.querySelector('.columnHeader') as HTMLElement;
    const scrollDiv = document.querySelector('.content') as HTMLElement;

    let isScrolling = false;

    if (scrollDiv) {
      scrollDiv.addEventListener('scroll', () => {
        if (!isScrolling) {
          isScrolling = true;

          requestAnimationFrame(() => {
            const x = scrollDiv.scrollLeft;
            const y = scrollDiv.scrollTop;
            // tableLeftFixedDiv ? tableLeftFixedDiv.style.top = -y + 'px' : '';
            // tableFreezFixedDiv ? tableFreezFixedDiv.style.left = -x + 'px' : '';
            // if (tableLeftFixedDiv) {
            //   tableLeftFixedDiv.style.top = -y + "em";
            //   tableLeftFixedDiv.offsetHeight;
            // }
            // if (tableFreezFixedDiv){
            //    tableFreezFixedDiv.style.left = -x + "em";
            //    tableFreezFixedDiv.offsetHeight;
            //   }
            if (tableFreezFixedDiv) {
              // tableFreezFixedDiv.style.willChange = "transform";
              // tableFreezFixedDiv.style.setProperty('transform', `translateX(${-x}px) translateY(0)`, 'important');
              // tableFreezFixedDiv.style.display = "none";
              tableFreezFixedDiv.style.left = -x + 'px';
            }
            if (tableLeftFixedDiv) {
              tableLeftFixedDiv.style.top = -y + 'px';
              //  tableLeftFixedDiv.style.transform = `translateY(${-y}px)`;
            }

            isScrolling = false;
          });
        }
      });
    }


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.properties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.preparemainChartData(this.customData);
      this.getData(this.chartMainData, 0, this.itemsPerPage, '', 'nosort');
      this.updatesig();
    }
  }


  updatesig() {
    this.SigValue = this.significanceValue;
    this.ConfidenceLevel = this.DefaultConfidenceLevel;
    this.Sig_LowerLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
    this.Sig_UpperLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
    this.preparemainChartData(this.customData);
    this.getData(this.chartMainData, 0, this.itemsPerPage, "", 'nosort');
  }

  maxData: any = 100;
  minData: any = -100;
  preparemainChartData(data: any) {
    this.chartMainData = [];
    // Reset stored originals when fresh data is loaded
    this.originalChartMainData = null;
    this.originalCategories = null;
    const metricValues = data?.metric_value ?? [];
    // const usePrimaryComparisonDataPoint =
    //   (this._configService.IndexSelected || this._configService.isIndexSelected || this.significanceValue !== "None") && metricValues.length > 1;
    // // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;

    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      metricValues.forEach((lev2: any) => {
        //  const dataPoints = usePrimaryComparisonDataPoint ? (lev2.data ?? []).slice(0, 1) : (lev2.data ?? []);
        const dataPoints = lev2.data ?? [];
        dataPoints.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length > 1 ? dataArr.colChild.split("|")[1] : dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && (dataArr.data2 == "NA" || dataArr.data2 == null || dataArr.data2 == undefined) ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? this.properties.CalculationLogic != "BIPS" ? true : false : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "isMultiPunch": dataArr.isMultiPunch
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      metricValues.forEach((lev2: any) => {
        const dataPoints = lev2.data ?? [];
        dataPoints.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": this.getSeriesName(dataArr),
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" && dataArr.data2 == null && dataArr.data2 == undefined ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "isMultiPunch": dataArr.isMultiPunch
          }
          this.chartMainData.push(d1);
        });
      });
    }

    this.maxData = Math.max(
      ...this.chartMainData
        .map((item: any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value: any) => !isNaN(value)) // Filter out invalid values like "NA"
    );
    this.minData = Math.min(
      ...this.chartMainData
        .map((item: any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value: any) => !isNaN(value)) // Filter out invalid values like "NA"
    );

  }

  getSeriesName(dataArr: any): string {
    const p = dataArr.colChild?.split('|');
    const isAudienceSnapshot = this._configService.selectedSnapshotType?.toLowerCase().includes('audience');
    
    if (isAudienceSnapshot && p?.length === 3 && p[0]?.toLowerCase() === 'audience') {
      return p[2];
    } else {
      return dataArr.colChild.split("|").length > 1
        ? dataArr.colChild.split("|")[1]
        : dataArr.colChild; 
    }
  }

  getBarWidth(value: any): string {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    const maxValue = Math.abs(this.maxData) > Math.abs(this.minData) ? Math.abs(this.maxData) : Math.abs(this.minData); // Set max value for scaling (adjust as needed)
    let percentage = (Math.abs(value) / maxValue) * (this.properties.CalculationLogic == 'None' ? 20 : 30); // Scale to 50%
    return `${percentage}%`;
  }

  getActualNumber(value: any) {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value;
  }

  getBarClass(value: any): string {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value >= 0 ? 'positive' : 'negative';
  }
  getMarginLeft(value: any): string {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value < 0 ? '0' : 'auto'; // Push positive bars to the right
  }

  isValueLessThanZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value < 0;
  }

  isValueGreaterThanZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value > 0;
  }

  isValueEqualToZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value == 0;
  }


  onTableDataChange(event: any) {
    this.p = event;
    this.start = (this.p - 1) * this.itemsPerPage;
    this.end = this.start + this.itemsPerPage;

    this.getData(this.tableData, this.start, this.end, " ", this.sorting);
  }
  //search($event) function to search the table data based on the input value
  search(event: any) {
    const input = event.target.value.toUpperCase();
    const table = this.customTable?.nativeElement;
    const rows = table?.querySelectorAll('.table-rows');

    if (rows) {
      rows.forEach((row: { querySelectorAll: (arg0: string) => any; style: { display: string; }; }) => {
        const cells = row.querySelectorAll('.data-cells');

        let rowMatch = false;

        cells.forEach((cell: { textContent: any; innerText: any; }) => {
          const textContent = cell.textContent || cell.innerText;
          if (textContent.toUpperCase().indexOf(input) > -1) {
            rowMatch = true;
          }
        });


        row.style.display = rowMatch ? '' : 'none';
      });
    }
    const rows2 = table?.querySelectorAll('.table-rows3');

    const headerCells = table?.querySelectorAll('.header-cells');
    if (headerCells) {
      headerCells.forEach((header: { textContent: any; innerText: any; }, index: number) => {
        const textContent = header.textContent || header.innerText;
        const columnCells = table.querySelectorAll(`.data-cells:nth-child(${index + 1})`);

        if (textContent.toUpperCase().indexOf(input) > -1) {
          columnCells.forEach((cell: { parentElement: { style: { display: string; }; }; }) => {
            if (cell.parentElement) {
              cell.parentElement.style.display = ''; // Show the entire column
            }

          });
        }
      });
    }
  }
  shouldShowRow(row: any) {
    // Get the category name from the row
    if (this.properties.suppressRow) {
      if (!this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }

        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });

        }

        return allValuesEmpty;
      }
    }
  }
  //getBorderStyle(side: string): string {
  //  let borderStyle = this.properties.borderStyle;
  //  if (this.properties.borderStyle === 'dotted') {
  //    // Increase border thickness by 1 if border style is 'dotted'
  //    borderStyle += ' ' + (parseInt(this.tableService.borderThickness) + 1) + 'px';
  //  } else {
  //    // Otherwise, use the original border thickness
  //    borderStyle += ' ' + this.tableService.borderThickness;
  //  }

  //  // Construct and return the border style for the specified side
  //  return borderStyle + ' ' + this.properties.border;
  //}


  shouldShowCol(col: any) {

    if (this.properties.suppressColumn) {
      if (!this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
    }


  }
  sortAscending(header: any, sortorder: any) {
    this.sorting = sortorder;
    this.sortDirectionAsc = !this.sortDirectionAsc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    // Implement sorting logic for ascending order based on the clicked header
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header, sortorder);
  }

  sortDescending(header: any, sortorder: any) {
    // Implement sorting logic for descending order based on the clicked header
    this.sorting = sortorder;
    this.sortDirectionDesc = !this.sortDirectionDesc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header, sortorder);
  }


  sortColumn(header: any, sortorder: any) {
    this.clickCounts[header] = this.clickCounts[header] || 0;

    // Increment the click count for the header
    this.clickCounts[header]++;

    // Now you have access to sortOrder (asc or desc) in your TypeScript logic
    if (!this.properties.transpose) {
      this.headers2 = this.headers.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    else {
      this.categories2 = this.categories.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    // Call  getData function
    // this.getData(this.tableData, this.start, this.end, header);
  }

  getNewSortOrder(clickCount: number): string {
    // Implement your logic here to determine the new sort order based on the click count
    const totalSortOrders = 2; // Assuming you have 2 sort orders: 'asc' and 'desc'
    return clickCount % totalSortOrders === 1 ? 'asc' : 'desc';

  }

  getData(chartData: any, start: any, end: any, colName: any, sortorder: any, skipSorting: boolean = false, preserveCategories: boolean = false) {
    // Limit the categories to 10 for the table view
    let seriesData: any[] = [];
    let valuesArray: any[][] = [];
    let deletedCategories: { categoryName: any; seriesWithEmptyValue: any[]; itemData: any[]; }[] = [];
    let sort = sortorder

    // Only re-extract categories if not preserving sorted order
    if (!preserveCategories) {
      if (this.properties.Transpose1) {

        this.headers = this.extractUniqueValues(chartData, 'Category Name');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });

        this.categories = this.extractUniqueValues(chartData, 'Series Name');
        this.categories2 = this.categories.map((category: string) => {
          return {
            colname: category, sortorder: category === colName ? sort : 'nosort'
          };
        });



      } else {

        this.headers = this.extractUniqueValues(chartData, 'Series Name');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });
        this.categories = this.extractUniqueValues(chartData, 'Category Name');
        this.categories2 = this.categories.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });
      }
    } else {
      // When preserving categories, just update the sortorder in categories2
      this.categories2 = this.categories.map((category: string) => {
        return { colname: category, sortorder: category === colName ? sort : 'nosort' };
      });
    }

    if (this.isOutput) {
      //if (this.properties.hideNA) {
        let columnName = 'Series Name';
        let RowName = 'Category Name';
        if (this.properties.Transpose1) {
          columnName = 'Category Name';
          RowName = 'Series Name';
        }
        let headercount = this.headers.length;
        let CategerioesCount = this.categories.length;
        this.headers = this.headers.filter((x: any) => {
          let count = 0;
          chartData.forEach((y: any) => {
            if (x == y[columnName]) {
              if (y['Label'] == null || y['Label'] == undefined || y['Label'] == "NA" || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
                count = count + 1;
              }
            }
          });
          if (count != CategerioesCount)
            return x;
        });

        const allCategories = [...this.categories];
        this.categories = this.categories.filter((x: any) => {
          let count = 0;
          chartData.forEach((y: any) => {
            if (x == y[RowName]) {
              if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
                count = count + 1;
              }
            }
          });
          if (count != headercount)
            return x;
        });
        // Store filtered-out categories so other components (e.g. shared-popup) can use the same hide logic
        this._configService.hiddenCategories = allCategories.filter(c => !this.categories.includes(c));
      

      if (this.properties.selectedColumn != undefined && !skipSorting) {
        if (this.properties.selectedsorting == "asc") {
          this.sortTableDataAscending(this.properties.selectedColumn)
        }
        else {
          this.sortTableDataDescending(this.properties.selectedColumn)
        }
      }

      if (this.properties.sort == "ascending") {
        this.headers.sort((a: any, b: any) => a.localeCompare(b));  // Sorts alphabetically
      } else if (this.properties.sort == "descending") {
        this.headers.sort((a: any, b: any) => b.localeCompare(a));  // Sorts in reverse alphabetical order
      }
    }

    this.headers1 = this.categories.slice(start, end);


    // if (!this.properties.Transpose) {
    //   const columnIndex = this.headers.indexOf(colName);
    //   if (columnIndex !== -1) {

    //     if (this.headers2[columnIndex].sortorder === 'asc') {
    //       this.sortTableDataAscending(colName);
    //     } else if (this.headers2[columnIndex].sortorder === 'desc') {
    //       this.sortTableDataDescending(colName);
    //     }
    //   }
    // }


  }

  HideNA(uniqueCategoryNames: any) {
    let columnName = 'Series Name';
    let RowName = 'Category Name';
    if (this.properties.Transpose1) {
      columnName = 'Category Name';
      RowName = 'Series Name';
    }
    this.headers = this.headers.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[columnName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
            count = count + 1;
          }
        }
      });
      if (count != this.headers.length)
        return x;
    });

    let categories = this.categories.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[RowName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0)) {
            count = count + 1;
          }
        }
      });
      if (count != this.categories.length)
        return x;
    });

    const common = uniqueCategoryNames.filter((value: any) => categories.includes(value));

    return common;
  }

  SortHideNA(uniqueCategoryNames: any, HideNAcategories: any) {
    const common = uniqueCategoryNames.filter((value: any) => HideNAcategories.includes(value));
    return common;
  }

 //BIPS sorting is not working with these changes. 
 //The bug IDs mentioned in the commit are linked to CT and BA, not Snapshot. 
 // However, this component used in Snapshot Only. 
  sortTableDataAscending1(seriesName: string): void {
    let column = 'Series Name';
    let row = 'Category Name';
    if (this.properties.Transpose1) {
      column = 'Category Name';
      row = 'Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
    if (filteredData.length > 0) {
      const groupedByBrand: { [key: string]: any[] } = {};
      const brandOrderMap: { [key: string]: number } = {};
      let orderIndex = 0;

      this.chartMainData.forEach((item: any) => {
        if (item[column] === seriesName) {
          const categoryName = item[row];
          // Extract brand name from pattern like "Brand Affinity - PARENT BRAND : Colgate : Bottom3Box"
          const brandMatch = categoryName.match(/:\s*([^:]+)\s*:/);
          const brandKey = brandMatch ? brandMatch[1].trim() : categoryName;

          if (!groupedByBrand[brandKey]) {
            groupedByBrand[brandKey] = [];
            brandOrderMap[brandKey] = orderIndex++;
          }
          groupedByBrand[brandKey].push(item);
        }
      });

      const brandOrder = Object.keys(groupedByBrand).sort((a, b) => brandOrderMap[a] - brandOrderMap[b]);
      const sortedValuesArray: any[] = [];
      brandOrder.forEach((brandKey: string) => {
        const brandGroup = groupedByBrand[brandKey];
        const sortedGroup = _.orderBy(brandGroup,
          [(item) => item['Rounded Value'] === 'NA' ? Infinity : item['Rounded Value']],
          ['asc']);
        sortedValuesArray.push(...sortedGroup);
      });
      // Update the original array with the sorted values for the specified seriesName
      let sortedIndex = 0;
      let sortedData = [];
      sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
        if (item[column] === seriesName) {
          const sortedItem = sortedValuesArray[sortedIndex];
          sortedIndex++;
          return sortedItem || item;
        }
        return item;
      });
      const extractedCategoryNames: string[] = sortedData
        .filter((item: { [x: string]: string }) => item[column] === seriesName)
        .map((item: { [x: string]: string }) => item[row]);

      const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));

      // Use the sorted uniqueCategoryNames directly as it already has the correct sorted order
      // Only filter to keep existing categories if needed
     // if (this.properties.hideNA) {
        // Filter uniqueCategoryNames to only include items that should be visible
        const oldCategories = this.categories;
        this.categories = uniqueCategoryNames.filter((cat: any) => oldCategories.includes(cat));
      // } else {
      //   this.categories = uniqueCategoryNames;
      // }

      this.categories2 = this.categories.map((category: string) => {
        return { colname: category };
      });


      this.chartMainData = [];
      this.chartMainData = sortedData;
      this.selectedColumn = seriesName;
      this.selectedascending = "asc";
      this.properties.selectedColumn = seriesName;
      this.properties.selectedsorting = "asc";
      for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
        if (this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
          this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(this.properties);
        }
      }
      // Refresh the view with sorted data (skipSorting=true to prevent recursion, preserveCategories=true to keep sorted order)
      this.getData(this.chartMainData, 0, this.itemsPerPage, seriesName, 'asc', true, true);
    }
    //  else{
    //   if(this.properties.hideNA){
    //     this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  sortTableDataAscending(seriesName: string, isUserAction: boolean = false): void {
    // Capture original state before the first sort
    if (!this.originalChartMainData) {
      this.originalChartMainData = _.cloneDeep(this.chartMainData);
    }
    if (!this.originalCategories) {
      this.originalCategories = [...this.categories];
    }
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
        //const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'asc');
        const sortedValuesArray =  _.orderBy(filteredData,
          [(item) => item['Rounded Value'] === 'NA' ? -Infinity : item['Rounded Value']],
          ['asc']);
        // Update the original array with the sorted values for the specified seriesName
        let sortedIndex = 0;
        let sortedData = [];
        sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
          if (item[column] === seriesName) {
            const sortedItem = sortedValuesArray[sortedIndex];
            sortedIndex++;
            return sortedItem || item;
          }
          return item;
        });
        const extractedCategoryNames: string[] = sortedData
          .filter((item: { [x: string]: string }) => item[column] === seriesName)
          .map((item: { [x: string]: string }) => item[row]);



        const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
        let categories:any
        // if(this.properties.hideNA)
        //   categories = this.HideNA(uniqueCategoryNames);
        // else
        //   categories = uniqueCategoryNames;
        this.categories = this.SortHideNA(uniqueCategoryNames,this.categories);

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category };
        });


        this.chartMainData= [];
        this.chartMainData = sortedData;
        this.selectedColumn = seriesName;
        this.selectedascending ="asc";
        this.properties.selectedColumn = seriesName;
        this.properties.selectedsorting ="asc";
        for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
          if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
            this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
          }
        }
     }
    //  else{
    //   if(this.properties.hideNA){
    //     this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  Transpose() {
    if (this.properties.Transpose1) {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Category Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Series Name');
    } else {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Series Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Category Name');
    }
  }

  sortTableDataDescending1(seriesName: string): void {
    let column = 'Series Name';
    let row = 'Category Name';
    if (this.properties.Transpose1) {
      column = 'Category Name';
      row = 'Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
    if (filteredData.length > 0) {
      const groupedByBrand: { [key: string]: any[] } = {};
      const brandOrderMap: { [key: string]: number } = {};
      let orderIndex = 0;

      this.chartMainData.forEach((item: any) => {
        if (item[column] === seriesName) {
          const categoryName = item[row];
          // Extract brand name from pattern like "Brand Affinity - PARENT BRAND : Colgate : Bottom3Box"
          const brandMatch = categoryName.match(/:\s*([^:]+)\s*:/);
          const brandKey = brandMatch ? brandMatch[1].trim() : categoryName;

          if (!groupedByBrand[brandKey]) {
            groupedByBrand[brandKey] = [];
            brandOrderMap[brandKey] = orderIndex++;
          }
          groupedByBrand[brandKey].push(item);
        }
      });

      const brandOrder = Object.keys(groupedByBrand).sort((a, b) => brandOrderMap[a] - brandOrderMap[b]);
      const sortedValuesArray: any[] = [];
      brandOrder.forEach((brandKey: string) => {
        const brandGroup = groupedByBrand[brandKey];
        const sortedGroup = _.orderBy(brandGroup,
          [(item) => item['Rounded Value'] === 'NA' ? -Infinity : item['Rounded Value']],
          ['desc']);
        sortedValuesArray.push(...sortedGroup);
      });

      // Update the original array with the sorted values for the specified seriesName
      let sortedIndex = 0;
      let sortedData = [];
      sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
        if (item[column] === seriesName) {
          const sortedItem = sortedValuesArray[sortedIndex];
          sortedIndex++;
          return sortedItem || item;
        }
        return item;
      });
      const extractedCategoryNames: string[] = sortedData
        .filter((item: { [x: string]: string }) => item[column] === seriesName)
        .map((item: { [x: string]: string }) => item[row]);

      const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));

      // Use the sorted uniqueCategoryNames directly as it already has the correct sorted order
      // Only filter to keep existing categories if needed
    //  if (this.properties.hideNA) {
        // Filter uniqueCategoryNames to only include items that should be visible
        const oldCategories = this.categories;
        this.categories = uniqueCategoryNames.filter((cat: any) => oldCategories.includes(cat));
      // } else {
      //   this.categories = uniqueCategoryNames;
      // }
      this.categories2 = this.categories.map((category: string) => {
        return { colname: category };
      });
      this.chartMainData = [];
      this.chartMainData = sortedData;
      this.selectedColumn = seriesName;
          this.selectedascending ="desc";
      this.properties.selectedColumn = seriesName;
          this.properties.selectedsorting ="desc";
          for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
            if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
              this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
        }
      }
      // Refresh the view with sorted data (skipSorting=true to prevent recursion, preserveCategories=true to keep sorted order)
      this.getData(this.chartMainData, 0, this.itemsPerPage, seriesName, 'desc', true, true);
    }
    //  else{
    //   if(this.properties.hideNA){
    //       this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  sortTableDataDescending(seriesName: string, isUserAction: boolean = false): void {
    // Capture original state before the first sort
    if (!this.originalChartMainData) {
      this.originalChartMainData = _.cloneDeep(this.chartMainData);
    }
    if (!this.originalCategories) {
      this.originalCategories = [...this.categories];
    }
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
         // const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'desc');
         const sortedValuesArray =  _.orderBy(filteredData,
          [(item) => item['Rounded Value'] === 'NA' ? Number.NEGATIVE_INFINITY : item['Rounded Value']],
          ['desc']);

          // Update the original array with the sorted values for the specified seriesName
          let sortedIndex = 0;
          let sortedData = [];
          sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
            if (item[column] === seriesName) {
              const sortedItem = sortedValuesArray[sortedIndex];
              sortedIndex++;
              return sortedItem || item;
            }
            return item;
          });
          const extractedCategoryNames: string[] = sortedData
            .filter((item: { [x: string]: string }) => item[column] === seriesName)
            .map((item: { [x: string]: string }) => item[row]);



          const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
          let categories:any
          // if(this.properties.hideNA)
          //   categories = this.HideNA(uniqueCategoryNames);
          // else
          //   categories = uniqueCategoryNames;
          this.categories =  this.SortHideNA(uniqueCategoryNames,this.categories);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category };
          });
          this.chartMainData = [];
          this.chartMainData = sortedData;
          this.selectedColumn = seriesName;
          this.selectedascending ="desc";
          this.properties.selectedColumn = seriesName;
          this.properties.selectedsorting ="desc";
          for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
            if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
              this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
            }
          }
     }
    //  else{
    //   if(this.properties.hideNA){
    //       this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }


  resetSort(): void {
    if (this.originalChartMainData) {
      this.chartMainData = _.cloneDeep(this.originalChartMainData);
    }
    if (this.originalCategories) {
      this.categories = [...this.originalCategories];
      this.categories2 = this.categories.map((category: string) => ({ colname: category, sortorder: 'nosort' }));
    }
    this.originalChartMainData = null;
    this.originalCategories = null;
    this.selectedColumn = '';
    this.selectedascending = '';
    this.properties.selectedColumn = undefined;
    this.properties.selectedsorting = undefined;
    for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
      if (this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
        this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(this.properties);
      }
    }
    this.getData(this.chartMainData, 0, this.itemsPerPage, '', 'nosort', true, true);
  }

 HideNA2(){
  let columnName='Series Name';
  let RowName='Category Name';
  if (this.properties.Transpose1){
    columnName='Category Name';
    RowName='Series Name';
    }
    let headercount = this.headers.length;
    let CategerioesCount = this.categories.length;
  this.headers= this.headers.filter((x:any)=>{
          let count=0;
          this.chartMainData.forEach((y:any)=>{
                if(x==y[columnName]){
                    if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                        count=count+1;
          }
        }
      });
          if(count!=headercount)
        return x;
    });

    this.categories = this.categories.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[RowName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined) {
            count = count + 1;
          }
        }
      });
      if (count != CategerioesCount)
        return x;
    });
  }

  /**
  * Mimics C# Math.Round(value, decimals) behavior
  * - Uses Banker's rounding (round to even)
  * - Returns a string (like JavaScript's .toFixed())
  */
  private toFixedLikeCSharp(value: number, decimals: number = 0): string {
    const factor = Math.pow(10, decimals);
    const scaled = value * factor;
    const fraction = scaled - Math.floor(scaled);

    let rounded: number;

    if (fraction > 0.5) {
      rounded = Math.ceil(scaled);
    } else if (fraction < 0.5) {
      rounded = Math.floor(scaled);
    } else {
      // Exactly halfway (.5) → round to even
      const floor = Math.floor(scaled);
      rounded = (floor % 2 === 0) ? floor : floor + 1;
    }

    const result = rounded / factor;
    return result.toFixed(decimals);
  }

  getDataCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else {
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }

    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      const sampleSize = Number(item['Sample size']);
      const isNonSuperAdmin = this._configService?.userRole != 'superadmin';
      const threshold = this._configService?.ISthreshold;
      const isLowSample = isNonSuperAdmin && !isNaN(sampleSize) && threshold != null && sampleSize <= threshold;

      if (this.properties.datalabelProperty == "default" || this.properties.datalabelProperty == "datalabel") {
        if (isLowSample && sampleSize > 0) {
          value = 'I/S';
        } else {
          const label = item['Label'];
          const isNA = (label == "" || label == "NA") && label != "0";
          if (isNA) {
            value = 'NA';
          } else {
            const num = Number(label);
            const fixed = this.toFixedLikeCSharp(num, this.properties.decimalRoundOff);
            const parsed = parseFloat(fixed);
            value = (parsed === 0 ? '0' : fixed) + (item['isPercentage'] ? '%' : '');
          }
        }
      } else if (this.properties.datalabelProperty == "change") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' + '</span>';
        }
      } else if (this.properties.datalabelProperty == "significance + changeVs") {
        if (isLowSample) {
          value = 'LS';
        } else {
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' + '</span>' + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      } else if (this.properties.datalabelProperty == "ls") {
        // Legacy 'ls' display mode, now respect role + threshold instead of 9000 magic number
        value = item['Rounded Value'] == "" ? 'NA' : (isLowSample ? 'LS' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : ''));
      } else if (this.properties.datalabelProperty == "significance") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          value = item['Rounded Value'] == 0 ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      } else if (this.properties.datalabelProperty == "significance2") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          let sig2 = item['Significance2'];
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : this.tableService.lowSignificance;
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          let changeTextColor = sig2 > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : 'black');
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:' + changeTextColor + '">(' + item["Change value vs PY"] + ')</span>' + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getBarColor(row: any, col: any): string {
  // const seriesName = this.properties.Transpose1 ? row : col;
  
  // if (Object.keys(this.globalColorMap).length === 0) {
  //   this.globalColorMap = this._configService.getGlobalColorMap();
  // }

  // if (this.globalColorMap && this.globalColorMap[seriesName]) {
  //   return this.globalColorMap[seriesName];
  // }

  // const prefixedKey = `Brands|${seriesName}`;
  // if (this.globalColorMap && this.globalColorMap[prefixedKey]) {
  //   return this.globalColorMap[prefixedKey];
  // }

  return '#1B3B6F';
}


  getChangeVsCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else {
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }

    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      if (this._configService.isIndexSelected == false) {
        if (this.SigValue != "None") {
          value = (item['Change value vs PY'] == null || item['Change value vs PY'] == "" || item['Change value vs PY'] == "NA") && item['Change value vs PY'] != 0 ? '(NA)' : "(" + parseFloat(Number(item['Change value vs PY'] * 100).toFixed(1)) + "%)";
        }
      }
      else if (this._configService.isIndexSelected == true) {
        value = (item['ValueForIndex'] == null || item['ValueForIndex'] == "" || item['ValueForIndex'] == "NA") && item['ValueForIndex'] != 0 ? '(NA)' : "(" + parseFloat(Number(item['ValueForIndex']).toFixed(1)) + ")";
      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getSigCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else{
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    let color:any;
    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      if (this._configService.isIndexSelected == false) {
        if (this.SigValue != "None") {
          color = item['Significance_Value'] < this.Sig_LowerLimt ? 'red' : (item['Significance_Value'] > this.Sig_UpperLimt ? 'green' : 'black');
        }
      }
      else {
        color = this._configService.CheckIndexColoring(String(item['ActualIndexValue']));
      }
      dataArray.push(color);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return (dataArray.join(''));
  }

  private extractUniqueValues(chartData: any, propertyName: string): string[] {
    return [...new Set(
      chartData
        .map((item: any) => item[propertyName])
        .flat()
        .filter((value: undefined) => value !== undefined)
    )] as string[];
  }



  customization() {
  const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Table", this._customSnapshotService.selectedSnapshotType?.name,cohortType));
  }
  commonfunc(event: any, customization: string, options: any) {
    let property;

    this.tableService.commonFunc(customization, event, this.properties, this.customTable, this.headerElement);
    this.itemsPerPage = this.properties.pagination ? this.categories.length : 10;
    this.getData(this.tableData, this.start, this.end, " ", this.sorting);

  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.tableService.applycustomization(event, item, this.properties)
    localStorage.setItem("properties", JSON.stringify(this.properties));
    //this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
    //this.properties.ColumnHeaderFontSize="0.5em";
  }

  hexToRgb(hex: string): string {
    // Remove the '#' if it's included
    hex = hex.replace('#', '');

    // Convert the hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `${r}, ${g}, ${b}`; // Returns rgb(r, g, b)
  }

  GetRowName(name: any) {
    if (!this.isOutput) {
      if (this._customSnapshotService.selectedSnapshotType.name == "Multiple Markets")
        return name.replace(/Brand/g, "Market")
      else
        return name;
    }
    else {
      return name;
    }
  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;

    return JSON.stringify(this.data).toString();
  }

  getMarginForScroll() {
    let tblRef: any = document.getElementById('table-scroll');
    if (tblRef != null) {
      let theadRef = tblRef.getElementsByTagName('thead');
      let fixedcolRef = tblRef.getElementsByClassName('FreezedColumn');
      let xscroll = fixedcolRef[0].clientWidth;
      if (this.properties?.Transpose1 != undefined) {
        fixedcolRef = tblRef.getElementsByTagName('tbody')[0].firstChild.clientWidth
        xscroll = Number(fixedcolRef) % this.categories.length + 1;
      }
      if (theadRef != null && theadRef.length > 0) {
        //return `${theadRef[0].clientHeight}px 0 0 ${fixedcolRef[0].clientWidth}px`;
        return `${theadRef[0].clientHeight}px 0 0 150px`;
      }
    }
    return 0;
  }

  index = -1;

  private isLowSample(sampleSize: any): boolean {
    const s = Number(sampleSize);
    if (isNaN(s)) return false;
    return (this._configService?.userRole != 'superadmin') && (this._configService?.ISthreshold != null) && s <= this._configService.ISthreshold;
  }
  shouldHideSignificance(cellValue: any): boolean {
    if (!cellValue) return true;

    // Convert the cell value to string and check for special values
    const cellString = cellValue.toString();

    // Check if the cell contains I/S, NA, or LS (case insensitive)
    return cellString.includes('I/S') ||
      cellString.includes('NA') ||
      cellString.includes('LS') ||
      cellString.includes('i/s') ||
      cellString.includes('na') ||
      cellString.includes('ls');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}


